module.exports = __webpack_public_path__ + "static/partnership_process_obj04@2x-e20833229aa6ceb3df081159a8193722.png";